import React, { useState } from "react";
import FormInput from "./FormInput";
import { formatUSPhoneNumber } from "../../../../util/stringformat";
type MyType = {
  fields?: any;
  submitTxt?: any;
  classname?: string; // default example: "col-md-10"
  inputClass?: any;
  onFormSubmit?: any;
  isModalOpen?: any;
  justify?: string; // default example: ""
  btnClass?: string; // default example: ""
  parentClass?: string; // default example: ""
};
export default function MyForm({
  fields,
  submitTxt,
  classname = "col-md-10",
  inputClass,
  onFormSubmit,
  isModalOpen,
  justify = "",
  parentClass,
  btnClass = "",
}: MyType = {}) {
  // console.log("fields", fields);

  const initialUserDetails = fields.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );
  const [userDetails, setUserDetails] = useState(initialUserDetails);
  const [errors, setErrors] = useState({});

  const validate = (name, value) => {
    let errorMsg = "";

    const isEmpty = (str) => !str || !str.trim();
    const isAlpha = (str) => /^[a-zA-Z\s]+$/.test(str);
    const isEmail = (str) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str);
    const isPhone = (str) => {
      if (str.length > 14) return false;

      const digitsOnly = str.replace(/\D/g, "");

      const validChars = /^[\d\s()+-]*$/;
      if (!validChars.test(str)) return false;

      return true;
    };

    if (isEmpty(value)) {
      errorMsg = "This field is required";
      return errorMsg;
    }

    switch (name) {
      case "user_name":
      case "username":
      case "name":
        if (!isAlpha(value)) {
          errorMsg = "User Name can only contain letters and spaces";
        } else if (value.length < 2) {
          errorMsg = "User Name must be at least 2 characters";
        } else if (value.length > 25) {
          errorMsg = "User Name cannot exceed 25 characters";
        }
        break;

      case "email":
        if (!isEmail(value)) {
          errorMsg = "Invalid email format";
        }
        break;

      case "phone":
        if (!isPhone(value)) {
          errorMsg = "Phone number must be 10 digits";
        }
        break;

      default:
        break;
    }

    return errorMsg;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setUserDetails((prev) => ({ ...prev, [name]: value }));

    const errorMsg = validate(name, value);
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    let formValid = true;
    const newErrors = {};

    for (const field of fields) {
      const err = validate(field.name, userDetails[field.name]);
      if (err) formValid = false;
      newErrors[field.name] = err;
    }
    setErrors(newErrors);
    if (formValid) {
      onFormSubmit(userDetails);

      setUserDetails(initialUserDetails);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={`row justify-content-${justify} ${parentClass} `}>
          {fields.map(({ name, type, placeholder }) => (
            <FormInput
              key={name}
              type={type}
              name={name}
              className={classname}
              InputclassName={inputClass}
              placeholder={placeholder}
              value={
                name === "phone"
                  ? formatUSPhoneNumber(userDetails[name])
                  : userDetails[name]
              }
              onChange={handleChange}
              error={errors[name]}
            />
          ))}
          <div className={`${btnClass}`}>
            <button
              type="submit"
              data-bs-toggle={isModalOpen ? "modal" : null}
              data-bs-target={isModalOpen ? "#quizModal" : null}
              className="quiz-btn"
            >
              {submitTxt}
            </button>
          </div>
        </div>
      </form>
    </>
  );
}
